<template>
  <div>
    <TopNav />

    <div class="vh-100 d-flex justify-content-center">
      <div class="form-access my-auto">
        <form @submit.prevent="submitForm">
          <span>Verifikasi Two-Factor Authentication</span>
          <p class="text-muted small mb-3">
            Masukkan kode 6 digit dari aplikasi Google Authenticator Anda.
          </p>
          <div class="form-group">
            <input
              type="text"
              class="form-control"
              placeholder="Kode 2FA"
              v-model="google_secret"
              inputmode="numeric"
              autocomplete="one-time-code"
              maxlength="6"
            />
          </div>
          <button type="submit" class="btn btn-gradient" :disabled="isLoading">
            {{ isLoading ? "Memverifikasi..." : "Verifikasi" }}
          </button>
        </form>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
// node_modules
import Cookies from "js-cookie";
import { useToast } from "vue-toastification";

// applibs
import themain from "@/applibs/themain.js";
import thestore from "@/applibs/thestore.js";

// components
import TopNav from "@/components/global/TopNav.vue";
import Footer from "@/components/global/Footer.vue";

const toast = useToast();

export default {
  components: {
    TopNav,
    Footer,
  },
  data() {
    return {
      themain,
      email: Cookies.get("temp_email"),
      password: Cookies.get("temp_password"),
      google_secret: "",
      isLoading: false,
    };
  },

  async beforeMount() {
    var self = this;

    if (
      self.email &&
      self.email != "" &&
      self.password &&
      self.password != ""
    ) {
      return;
    }

    Cookies.remove("jwt");
    Cookies.remove("usid");
    Cookies.remove("temp_email");
    Cookies.remove("temp_password");
    self.$router.push("/auth/login");
  },

  methods: {
    async submitForm() {
      var self = this;

      if (!self.google_secret || self.google_secret.trim() === "") {
        toast.warning("Kode 2FA wajib diisi");
        return;
      }

      self.isLoading = true;

      try {
        var res = await thestore.postAuthLoginTwoFa(
          self.email,
          self.password,
          self.google_secret.trim()
        );

        if (res.success == true && res.action == "login_complete") {
          Cookies.remove("temp_email");
          Cookies.remove("temp_password");
          Cookies.remove("jwt"); // drop legacy JS-readable jwt; HttpOnly cookie is set by API
          Cookies.set("usid", res.usid, {
            expires: 7,
            secure: true,
            sameSite: "lax",
          });
          if (typeof self.pgxSocketAuthenticate === "function") {
            self.pgxSocketAuthenticate(res.token);
          }
          self.$router.push("/");
        } else {
          toast.warning(res.msg || "Kode 2FA tidak valid");
        }
      } finally {
        self.isLoading = false;
      }
    },
  },
};
</script>
